/** When a change was made, for a notice: the time of day for today ("18:41:07"), the date too for an older one. */
export function whenText(atMs: number, nowMs: number): string {
  const at = new Date(atMs);
  return at.toDateString() === new Date(nowMs).toDateString() ? at.toLocaleTimeString() : at.toLocaleString();
}
